import {Icon24Back, Icon24CheckCircleOutline, Icon24QuestionOutline} from "@vkontakte/icons";
import {Button, Cell, Div, Input, List} from "@vkontakte/vkui";
import React from "react";
import * as constants from "./constants";
import {AdaptivityContext} from "./constants";


class Autocomplete extends React.Component {

    state = {
        value: '',
        label: '',
        numItems: 7,
        showList: false,
        onBottom: false,
        onRight: false
    }

    constructor(props) {
        super(props);

        this.guid = constants.getGUID()
        this.ref = React.createRef()

        if (this.props.value) {
            this.state.label = this.props.value
        }
        if (this.props.numItems) {
            this.state.numItems = this.props.numItems
        }
    }

    checkScroll() {

        if (!this.ref.current) return
        this.currentTop = this.ref.current.getBoundingClientRect().bottom
        this.currentLeft = this.ref.current.getBoundingClientRect().left
    }

    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "openKBInput" && event.data.guid != this.guid) {
                this.setState({showList: false})
            }
        }
    }
    handleScroll = () => {
        this.checkScroll()
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false)
        window.addEventListener('scroll', this.handleScroll);
        this.checkScroll()
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.value != this.props.value) {
            this.setState({value: this.props.value})
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener("message", this.receiveMessage)
    }

    checkShowList = (e) => {
        e.stopPropagation()
            //if (this.state.label.toString().length < 2) return;
        if (this.props.readonly && this.props.readonlyError) {
            this.props.readonlyError()
        }

        if (this.props.readonly) return
        const onBottom = this.currentTop + 250 > window.innerHeight;
        const onRight = this.currentLeft + 150 > window.innerWidth;


        window.postMessage({type: 'openAutocomlete', guid: this.guid})
        this.setState({showList: true, onBottom, onRight})
    }

    render() {

        const items = []

        if ( this.props.items && this.state.showList) {
            this.props.items.map(el => {
                if (el.label.toString().toLowerCase().indexOf(this.state.label.toLowerCase()) === -1) return
                if (items.length >= this.state.numItems) return
                items.push(el)
            })
        }
        return (
            <div ref={this.ref} className="Autocomlete" style={{...this.props.style}}>

                <Input type="text"
                       name={this.props.name}
                       placeholder={this.props.placeholder}
                       after={this.props.after}
                       value={this.state.label}
                       type={this.props.type}
                       autoComplete="off"
                       onChange={e => {
                           this.setState({label: e.currentTarget.value})
                           if (this.props.onChange) {
                               this.props.onChange(e.currentTarget.value)
                           }
                           setTimeout(() => this.checkShowList(e), 500)
                       }}

                       onClick={this.checkShowList}

                />
                {this.state.showList && items &&
                    <div
                        className={"autocomplete-wrapper" + (this.state.onBottom ? " on-bottom" : '') + (this.state.onRight ? " on-right" : '')}
                        style={{
                            minWidth: AdaptivityContext.isMobile ? '200px' : '400px',
                            marginTop: this.state.onBottom ? (-65 - items.length * 48) + 'px' : 'inherit'
                        }}>
                        <List>{
                            items.map(el => (
                                    <Cell onClick={() => {
                                        this.setState({value: el.value, label: el.label})
                                        this.setState({showList: false})
                                        if (this.props.onChange) {
                                            this.props.onChange(el.label)
                                        }

                                    }}>{el.label}</Cell>
                                )
                            )
                        }
                        </List>

                    </div>}
            </div>
        )
    }
}

export default Autocomplete